import { TInputField } from "../../../providers/ModernAcquisitionProvider/types";

export const isFieldInvalid = (field: Partial<TInputField>) => !isFieldValid(field);
export const isFieldValid = (field: Partial<TInputField>) => {
    return field && field.errorType === 'None'
}